/**
 * External tool URLs for the Admin panel Tools page.
 *
 * Configure via REACT_APP_TOOL_* env vars (see docker-compose.yml /
 * docker-compose.ec2.yml). CRA picks these up when the admin-panel
 * container starts. Empty / unset → tile is disabled (or Coming Soon).
 */

const env = (key) => {
    const value = process.env[key];
    if (value == null || String(value).trim() === '') return '';
    return String(value).trim().replace(/\/+$/, '');
};

export const TOOL_URLS = {
    systemMonitoring: env('REACT_APP_TOOL_SYSTEM_MONITORING_URL'),
    dataCollector: env('REACT_APP_TOOL_DATA_COLLECTOR_URL'),
    verificationTool: env('REACT_APP_TOOL_VERIFICATION_URL'),
    annotationTool: env('REACT_APP_TOOL_ANNOTATION_URL'),
    observability: env('REACT_APP_TOOL_OBSERVABILITY_URL'),
    landingAdmin: env('REACT_APP_TOOL_LANDING_ADMIN_URL'),
    developerPortal: env('REACT_APP_TOOL_DEVELOPER_PORTAL_URL'),
};

/** Open an external tool URL in a new browser tab. */
export function openTool(url) {
    if (!url) return;
    window.open(url, '_blank', 'noopener,noreferrer');
}
